import LegalDoc from "@/components/LegalDoc";
import { AVISO_LEGAL } from "@/data/avisoLegal";

export default function AvisoLegal() {
  return <LegalDoc doc={AVISO_LEGAL} testId="aviso-legal-page" />;
}
